export default __webpack_public_path__ + "fonts/campton-semibold-webfont.woff2";